module.exports = __webpack_public_path__ + "static/media/home_screen_background.310740fd.jpg";